import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import addMonths from 'date-fns/addMonths';
import { withTranslation } from 'react-i18next';
import createAccessRightService from '../services/createAccessRightService';
import AccessRightFormModal from './AccessRightFormModal';

let now;
const getNowOnce = () => {
  if (!now) {
    now = new Date();
    now.setHours(now.getHours(), 0, 0, 0);
  }
  return now;
};

let future;
const getFutureOnce = () => {
  if (!future) {
    future = addMonths(getNowOnce(), 6);
  }
  return future;
};
class NewAccessRightModal extends PureComponent {
  handleSubmit = body => {
    const { dispatchCreateAccessRightPost, returnRoute } = this.props;
    dispatchCreateAccessRightPost(body, returnRoute);
  };
  render() {
    const { open, createAccessRightFetch, vehicleId, returnRoute, t } = this.props;
    if (!open) {
      return null;
    }
    return (
      <AccessRightFormModal
        header={t('newAccessRight')}
        onSubmit={this.handleSubmit}
        submitProcessing={!!createAccessRightFetch.pending}
        vehicleId={vehicleId}
        returnRoute={returnRoute}
        data={{
          vehicleId,
          stateId: 1,
          validFrom: getNowOnce(),
          validUntil: getFutureOnce(),
        }}
      />
    );
  }
}

NewAccessRightModal.propTypes = {
  t: PropTypes.func.isRequired,
  dispatchCreateAccessRightPost: PropTypes.func.isRequired,
  createAccessRightFetch: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  vehicleId: PropTypes.string,
  returnRoute: PropTypes.string,
};

NewAccessRightModal.defaultProps = {
  vehicleId: undefined,
  returnRoute: '/all-accessrights',
};

export default compose(withTranslation(), createAccessRightService)(NewAccessRightModal);
